// Doit rester aligné avec les CLASSIFICATION_* de nabook-server (routes/main/library/home/utils.js)
export const DEFAULT_CLASSIFICATION = 3;

export const HOME_PAGES = [
  { value: DEFAULT_CLASSIFICATION, label: "Utilisateur FR (défaut)" },
  { value: -11, label: "Enseignant FR" },
  { value: -6, label: "Enseignant FR (prod-nc)" },
  { value: -12, label: "Élève Edifice FR" },
  { value: -7, label: "Élève Edifice FR (prod-nc)" },
  { value: -10, label: "Utilisateur ENG" },
  { value: -5, label: "Bilingue" },
];

export const getHomePageLabel = (classification) =>
  HOME_PAGES.find((h) => h.value === classification)?.label ??
  `Classification ${classification}`;
